import { AxiosInstance } from 'axios';
import { generateNotification, mapReplacer } from '..';
import i18n from '../../../client/src/i18n/i18n';
import { NotificationType } from '../notification/notification.types';
import { Schedule } from '../project/Project.types';

/**
 * API Method to create a new user absence schedule
 * @param axios instance of axios
 * @param schedule the client side created schedule
 * @returns Promise containing the server side updated instance or undefined on error
 */
export const createNewAbsenceSchedule = async (
  axios: AxiosInstance,
  schedule: Schedule,
): Promise<Schedule | undefined> => {
  return axios
    .post('/schedule/', JSON.stringify(schedule, mapReplacer))
    .then((res) => res.data)
    .catch((exc) => {
      console.error('Error while saving schedule', exc);
      generateNotification({
        type: NotificationType.ERROR,
        value: i18n.t('general.notification.error.saveAbsenceSchedule'),
      });
      return undefined;
    });
};

/**
 * API Method to update a user schedule
 * @param axios instance of axios
 * @param schedule the client side updated schedule
 * @returns Promise containing the server side updated schedule or undefined on error
 */
export const updateAbsenceSchedule = async (
  axios: AxiosInstance,
  schedule: Schedule,
): Promise<Schedule | undefined> => {
  return axios
    .post('/schedule/update', JSON.stringify(schedule, mapReplacer))
    .then((res) => res.data)
    .catch((exc) => {
      console.error('Error while saving schedule', exc);
      generateNotification({
        type: NotificationType.ERROR,
        value: i18n.t('general.notification.error.updateAbsenceSchedule'),
      });
      return undefined;
    });
};

/**
 * API Method to delete a user schedule
 * @param axios instance of axios
 * @param scheduleId the id of the schedule to delete
 * @returns Promise containing true or false for success
 */
export const deleteAbsenceSchedule = async (
  axios: AxiosInstance,
  scheduleId: string,
): Promise<boolean> => {
  return axios
    .post('/schedule/delete', scheduleId, { headers: { 'Content-Type': 'text/plain' } })
    .then((res) => res.status === 200)
    .catch((exc) => {
      console.error('Error while saving schedule', exc);
      generateNotification({
        type: NotificationType.ERROR,
        value: i18n.t('general.notification.error.deleteAbsenceSchedule'),
      });
      return false;
    });
};
